export const STATUS_OPTIONS = [
  {
    label: 'All',
    value: '',
  },
  {
    label: 'Pending',
    value: 'pending',
  },
  {
    label: 'Done',
    value: 'completed',
  },
];

export const DATE_RANGE_OPTIONS = [
  {
    label: 'Last 7 Days',
    value: '7',
  },
  {
    label: 'Last 30 Days',
    value: '30',
  },
  {
    label: 'Last 90 Days',
    value: '90',
  },
];

export const TASK_TYPES = [
  {
    value: 'hourly',
    label: 'Hourly',
  },
  {
    value: 'checklist',
    label: 'Checklist',
  },
  {
    value: 'playable',
    label: 'Stop-Play',
  },
  {
    value: 'summary',
    label: 'Summary',
  },
];
